export enum UtmSource {
  CUSTOMER = 'customer',
  PARTNER = 'partner',
}
